import { ArrowUpRight, RotateCcw } from "lucide-react";
import { Link, useNavigate } from "../app/router";
import { Brand } from "./Brand";
import { clearSavedDesign } from "../lib/storage";

export function SiteFooter() {
  const navigate = useNavigate();
  const reset = () => {
    if (!window.confirm("Xóa bản phác và bắt đầu lại? Thao tác này chỉ xóa dữ liệu demo trên trình duyệt.")) {
      return;
    }
    clearSavedDesign();
    window.dispatchEvent(new Event("reunang-storage"));
    navigate("/thiet-ke?reset=1");
  };

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Brand />
          <p>
            Đúng nắng. Vừa công chăm.
            <br />
            Hợp nếp nhà.
          </p>
        </div>
        <div>
          <h2 className="footer-heading">Khám phá</h2>
          <Link to="/phong-cach">Ba nếp xanh</Link>
          <Link to="/thu-vien-cay">Thư viện 12 cây</Link>
          <Link to="/goi-dich-vu">Gói dịch vụ</Link>
        </div>
        <div>
          <h2 className="footer-heading">Dùng thử</h2>
          <Link to="/thiet-ke">
            Mở Xưởng ban công <ArrowUpRight size={16} aria-hidden="true" />
          </Link>
          <Link to="/cam-nang">Checklist đo 5 phút</Link>
          <button className="footer-reset" type="button" onClick={reset}>
            <RotateCcw size={15} aria-hidden="true" /> Reset demo
          </button>
        </div>
        <div className="footer-note">
          <span className="eyebrow">Một sản phẩm mẫu của LDKTech</span>
          <p>
            Rêu Nắng là thương hiệu và bộ dữ liệu hư cấu, được dựng để minh họa năng lực sản phẩm số.
          </p>
          <p className="ldktech-service-credit">
            Cần một web app vận hành riêng?{" "}
            <a href="https://ldktech.com/dich-vu/web-app/">
              Xem dịch vụ Web App của LDK Tech
              <ArrowUpRight size={15} aria-hidden="true" />
            </a>
          </p>
        </div>
      </div>
      <div className="container footer-bottom">
        <span>© 2026 Rêu Nắng · demo hư cấu</span>
        <span>Không thanh toán · không tài khoản · không backend</span>
      </div>
    </footer>
  );
}
